import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import './FAQAccordion.css';

export default function FAQAccordion({ title = "Frequently Asked Questions", faqs = [], accentColor = "#06b6d4" }) {
  const [openIndex, setOpenIndex] = useState(0); // First item open by default

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="faq-accordion-container">
      {title && <h2 className="faq-accordion-title">{title}</h2>}
      
      <div className="faq-accordion-list">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <div 
              key={faq.q} 
              className={`faq-accordion-item${isOpen ? ' active' : ''}`}
            >
              <button 
                className="faq-accordion-header"
                onClick={() => toggleIndex(index)}
                aria-expanded={isOpen}
              >
                <span style={{ color: isOpen ? accentColor : '#f5f5f5' }}>{faq.q}</span>
                <div 
                  className="faq-icon-wrapper"
                  style={{ 
                    background: isOpen ? `${accentColor}20` : undefined,
                    color: isOpen ? accentColor : undefined 
                  }}
                >
                  <ChevronDown size={18} />
                </div>
              </button>

              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                    style={{ overflow: 'hidden' }}
                  >
                    <div className="faq-accordion-content">
                      <p>{faq.a}</p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </div>
  );
}
